import { createContext } from 'react';

import {
  DocumentReference,
  DocumentsSummary,
  DocumentSummaryEntry,
} from '@totem/components/documents/types';
import { Filter } from '@totem/types/common';

interface Context {
  loading: boolean;
  data: DocumentSummaryEntry[];
  totalRecords: number;
  action: string;
  actionItem: DocumentSummaryEntry;
  onAction?: (action: string, docEntry: DocumentSummaryEntry) => void;
  // Filters sent with the last documents request, including reference and static filters.
  filters: Filter[];
  selectedDocuments: DocumentSummaryEntry[];
  setDocumentSelected: (
    docEntry: DocumentSummaryEntry,
    selected: boolean,
  ) => void;
  documentReference: DocumentReference;
  documentReferenceInternal: boolean;
  // Counts across every document the user can see (not just the current page or filters).
  summary: DocumentsSummary | null;
  // Every document matching the current filters and sort, for export.
  fetchAllDocuments: () => Promise<DocumentSummaryEntry[]>;
}

export default createContext<Context>({
  loading: false,
  data: [],
  totalRecords: 0,
  action: '',
  actionItem: null,
  onAction: () => {},
  filters: [],
  selectedDocuments: [],
  setDocumentSelected: () => {},
  documentReference: null,
  documentReferenceInternal: false,
  summary: null,
  fetchAllDocuments: () => Promise.resolve([]),
});
